import React from "react";
import { PopupAnimation } from "@learningblocks/storybook-components";
import animationOne from "../animations/HoldCuvette.json";

export function HoldTheCuvetteModal(props: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const [watched, setWatched] = React.useState(false);

  return (
    <PopupAnimation
      open={props.isOpen}
      label={
        "Learn how to hold and orient the blank cuvette filled with water."
      }
      watched={watched}
      setWatched={() => setWatched(true)}
      onClose={props.onClose}
      animationData={animationOne}
      showControls={false}
    />
  );
}
